import Button from "@app/sharedComponents/Button/Button";
import { ThemedText, ThemedView } from "@app/theme";
import { formatIndianCurrency } from "@app/utils/utility";

const InterestBreakUp =({closeBottomSheet,interestDetails})=>{
    const {outstandingInterest,outStandingCharges,totalAmount} = interestDetails
    return(
        <ThemedView p="lg">
            <ThemedText variant='b2s' color='text-primary'>Total due</ThemedText>
            <ThemedView p="md" borderColor='border-primary' borderWidth={1} borderRadius='md' my="lg">
                <ThemedView flexDirection='row' justifyContent='space-between' >
                    <ThemedText variant='b3r' color='text-secondary'>Outstanding interest</ThemedText>
                    <ThemedText variant='b3m' color='text-primary'>₹{formatIndianCurrency(outstandingInterest)}</ThemedText>
                </ThemedView>
                <ThemedView height={1} my="md" backgroundColor="border-primary" width={'100%'} />
                <ThemedView flexDirection='row' justifyContent='space-between' >
                    <ThemedText variant='b3r' color='text-secondary'>Outstanding charges </ThemedText>
                    <ThemedText variant='b3m' color='text-primary'>₹{formatIndianCurrency(outStandingCharges)}</ThemedText>
                </ThemedView>
                <ThemedView height={1} my="md" backgroundColor="border-primary" width={'100%'} />

                <ThemedView flexDirection='row' justifyContent='space-between' >
                    <ThemedText variant='b3s' color='text-primary'>Total due</ThemedText>
                    <ThemedText variant='b3s' color='text-primary'>₹{formatIndianCurrency(totalAmount)}</ThemedText>
                </ThemedView>
            </ThemedView>
            <Button label="Ok, got it!" handlePress={closeBottomSheet} />
        </ThemedView>
    )
}

export default InterestBreakUp;